import React, { useEffect, useState } from 'react';
import './company-introduction.css';
import Footer from '../../layout/footer/footer';
import { loadConfigs } from '../../services/configService';

const unwrapPayload = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  let current = payload;
  const visited = new Set();

  while (
    current &&
    typeof current === 'object' &&
    'data' in current &&
    current.data !== current &&
    !visited.has(current)
  ) {
    visited.add(current);
    current = current.data;
  }

  return current;
};

const findNotificationContent = (source) => {
  if (!source) {
    return '';
  }

  if (typeof source === 'string') {
    return source;
  }

  if (Array.isArray(source)) {
    for (const item of source) {
      const value = findNotificationContent(item);
      if (value) {
        return value;
      }
    }
    return '';
  }

  if (typeof source !== 'object') {
    return '';
  }

  for (const [key, value] of Object.entries(source)) {
    if (typeof key === 'string' && key.toLowerCase() === 'notificationcontent') {
      if (value) {
        return value;
      }
    }
  }

  for (const value of Object.values(source)) {
    const nestedValue = findNotificationContent(value);
    if (nestedValue) {
      return nestedValue;
    }
  }

  return '';
};

const CompanyIntroduction = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const payload = await loadConfigs();
        const configs = unwrapPayload(payload);
        const primaryConfig = Array.isArray(configs?.items) && configs.items.length > 0
          ? configs.items[0]
          : configs;
        const htmlContent = findNotificationContent(primaryConfig);
        setContent(htmlContent || '');
        setError(false);
      } catch (err) {
        console.error('Failed to load notification content', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  const renderContent = () => {
    if (loading) {
      return <p className="company-introduction__status">در حال بارگذاری...</p>;
    }

    if (error) {
      return (
        <p className="company-introduction__status company-introduction__status--error">
          در دریافت اطلاعات خطایی رخ داده است. لطفاً مجدداً تلاش کنید.
        </p>
      );
    }

    if (!content) {
      return (
        <p className="company-introduction__status">
          محتوایی برای نمایش وجود ندارد.
        </p>
      );
    }

    return (
      <div
        className="company-introduction__html"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  };

  return (
    <>
      <section className="company-introduction" style={{marginTop:'40px'}}>
        <div className="container">
          <h1 className="company-introduction__title">معرفی شرکت</h1>
          <div className="company-introduction__content-box">
            {renderContent()}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CompanyIntroduction;
